export const REDIRECT_ROUTE = {
  path: '/login',
};

export default REDIRECT_ROUTE;
